// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2372":"css/admin-app.6783","6729":"css/app.6783"}[chunkId] + ".css";
};